import { render, staticRenderFns } from "./ChannelMembers.vue?vue&type=template&id=27ac44c6&scoped=true"
import script from "./ChannelMembers.vue?vue&type=script&lang=js"
export * from "./ChannelMembers.vue?vue&type=script&lang=js"
import style0 from "./ChannelMembers.vue?vue&type=style&index=0&id=27ac44c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ac44c6",
  null
  
)

export default component.exports